import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import DataExtractorGridLayout from './containers/Grid'

export default function DataExtractorLayout() {
  return <Router>
    <PrivateRoute path="/settings/data-extractors" component={DataExtractorGridLayout} />
  </Router>
}
